import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../api/adminApi";
import useClientContext from "../../../context/useClientContext";
import { getPageStatusFromPortalSettings } from "../investor-portal/pages/portalPageStatusHelper";

const useIsNewsVisibleToInvestors = (): boolean => {
  const { hasAnyPermission } = useClientContext();

  const canViewPortalSettings = hasAnyPermission(["ViewInvestorPortalSettings", "ManageInvestorPortalSettings"]);

  const [portalSettings, fetchPortalSettingsError] = useFetch(adminApi.getInvestorPortalSettings, {
    disabled: !canViewPortalSettings,
  });

  if (fetchPortalSettingsError) {
    logError(fetchPortalSettingsError, "[useIsNewsVisibleToInvestors] getInvestorPortalSettings");
  }

  if (portalSettings === undefined) {
    return true;
  }

  return getPageStatusFromPortalSettings("News", portalSettings.settings) === "live";
};

export default useIsNewsVisibleToInvestors;
